class Permission {
  VIEWER = 'viewer';
  ADMIN = 'admin';
  OWNER = 'owner';
}

const PermissionFactory = (permission) => new Permission(permission);

export default PermissionFactory;
